@if (syncStatus.upToDate || syncStatus.required || syncStatus.optional || syncStatus.failed) {
  <div id="offlineProgressBarContainer" class="offline-progress-container">
    <div id="progressBarContainer" class="progress-bar-container">
      <div id="leftProgressBar" class="parallelogram" [ngClass]="{'parallelogram-sync-required': syncStatus.required || syncStatus.failed}" [style.width]="progressBarWidth.left" [style.transform]="progressBarWidth.leftSkew"></div>
      <div id="rightProgressBar" class="reverseParallelogram" [style.width]="progressBarWidth.right"></div>
    </div>
    <div id="offlineProgressBarMessage" class="message" (click)="(syncStatus.required || syncStatus.failed) && tryGoOnline()"
      [ngClass]="{'cursor': syncStatus.required || syncStatus.failed}">
      <span id="expirationMessage" class="expiration-message">{{expirationMessage}}@if (syncStatus.required || syncStatus.failed) {
        <span class="crm-industrial-font icon-refresh"></span>
      }</span>
      @if (syncStatus.optional) {
        <span id="considerRefreshingMessage" class="consider-refreshing cursor" (click)="tryGoOnline()">
          {{appStrings.goOffline_considerRefresh}}<span class="crm-industrial-font icon-refresh"></span>
        </span>
      }
    </div>
  </div>
}
